<div
  class="player-card d-flex align-items-center gap-3"
  [class.player-card--reverse]="rightImage"
  [matTooltip]="displayTooltip ? tooltip : ''"
  *ngIf="user"
>
  <!-- Avatar screen bezel -->
  <div class="player-card__bezel flex-shrink-0">
    <span class="player-card__screw player-card__screw--tl"></span>
    <span class="player-card__screw player-card__screw--tr"></span>
    <span class="player-card__screw player-card__screw--bl"></span>
    <span class="player-card__screw player-card__screw--br"></span>
    <span class="player-card__status-led"></span>

    <div class="player-card__avatar-wrap">
      <div class="tp-box" *ngIf="user?.userData?.avatarUrl">
        <div class="front">
          <app-s3-image
            [isRounded]="true"
            [image]="user?.userData?.avatarUrl"
            [avatarName]="user?.userData.nickname"
          ></app-s3-image>
        </div>
        <div class="back">
          <app-s3-image [isRounded]="true" [image]="user?.avatarUrl" [avatarName]="user?.username"></app-s3-image>
        </div>
      </div>
      <div class="tp-box tp-box--no-cursor" *ngIf="!user?.userData?.avatarUrl">
        <app-s3-image [isRounded]="true" [image]="user?.avatarUrl" [avatarName]="user?.username"></app-s3-image>
      </div>
    </div>
  </div>

  <!-- Player readout -->
  <div
    class="player-card__readout d-flex flex-column justify-content-center min-w-0 flex-grow-1"
    *ngIf="displayUserName"
  >
    {{ user?.username }}
  </div>
</div>
